import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UnitService, AuthService } from '../services/api';
import { unitTypeLabels } from '../constants/unitTypes';
import { FaTable, FaBuilding, FaArrowRightFromBracket, FaChevronDown, FaCalendar } from 'react-icons/fa6';
import logo from '../assets/logo.png';
import './Dashboard.css';
import './UnitDetail.css'; // Réutiliser les styles
import Message from './Message';

const AddUnit = () => {
    const [newUnit, setNewUnit] = useState({ name: '', type: '', start_dt: '', end_dt: '' });
    const [formError, setFormError] = useState('');
    const [formLoading, setFormLoading] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const navigate = useNavigate();

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewUnit(prev => {
            const updated = { ...prev, [name]: value };
            if (name === 'start_dt' && updated.end_dt && new Date(value) > new Date(updated.end_dt)) {
                updated.end_dt = '';
            }
            return updated;
        });
    };

    const handleSubmitUnit = async (e) => {
        e.preventDefault();
        if (!newUnit.name.trim() || !newUnit.type || !newUnit.start_dt || !newUnit.end_dt) {
            setFormError('Tous les champs sont requis.');
            return;
        }

        try {
            setFormLoading(true);
            setFormError('');
            await UnitService.createUnit(newUnit);
            navigate('/dashboard');
        } catch (err) {
            console.error('Erreur lors de la création du groupe :', err);
            setFormError(err.response?.data?.error || 'Une erreur est survenue.');
        } finally {
            setFormLoading(false);
        }
    };

    // Calcul de la date de fin maximale autorisée
    let endDateMax = '';
    if (newUnit.start_dt) {
        const startDate = new Date(newUnit.start_dt);
        let year = startDate.getFullYear();
        const august31 = new Date(year, 7, 31); // Mois 7 = Août

        if (startDate > august31) {
            year += 1;
        }
        endDateMax = `${year}-08-31`;
    }

    return (
        <div id="dashboard-container">
            <div id="dashboard-layout">
                <aside id="sidebar" className={sidebarOpen ? 'open' : ''}>
                    <div id="sidebar-header">
                        <h1><img src={logo} alt="Fiche Santé Logo" style={{ height: '30px', marginRight: '10px' }} /> Fiche Santé</h1>
                    </div>
                    <nav id="sidebar-nav">
                        <ul>
                            <li><span className="active" onClick={() => navigate('/dashboard')}><FaTable /><span>Tableau de bord</span></span></li>
                            <li><span onClick={() => navigate('/organization')}><FaBuilding /><span>Mon organisation</span></span></li>
                        </ul>
                    </nav>
                </aside>

                <main id="main-content">
                    <header id="header">
                        <button type="button" className="sidebar-toggle" aria-label="Menu" aria-expanded={sidebarOpen} onClick={() => setSidebarOpen(!sidebarOpen)}>
                            ☰
                        </button>
                        <div>
                            <h2>Créer un groupe</h2>
                        </div>
                        <div>
                            <button onClick={() => { AuthService.logout(); navigate('/signin'); }} className="logout-button" aria-label="Déconnexion">
                                <FaArrowRightFromBracket />
                                <span>Déconnexion</span>
                            </button>
                        </div>
                    </header>

                    {sidebarOpen && <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)}></div>}

                    <section id="edit-unit-section">
                        <div id="edit-unit-container">
                            <div id="unit-details-card">
                                <h3>Nouveau groupe / Nouveau séjour</h3>
                                {formError && <Message>{formError}</Message>}
                                <form id="unit-form" onSubmit={handleSubmitUnit}>
                                    <div>
                                        <label htmlFor="name">Nom :</label>
                                        <input type="text" id="name" name="name" value={newUnit.name} onChange={handleInputChange} required />
                                    </div>

                                    <div>
                                        <label htmlFor="type">Type :</label>
                                        <div className="select-wrapper">
                                            <select id="type" name="type" value={newUnit.type} onChange={handleInputChange} required>
                                                <option value="">Sélectionnez un type</option>
                                                {Object.entries(unitTypeLabels).map(([value, label]) => (
                                                    value && <option key={value} value={value}>{label}</option>
                                                ))}
                                            </select>
                                            <FaChevronDown />
                                        </div>
                                    </div>

                                    <div className="form-grid">
                                        <div>
                                            <label htmlFor="start_dt">Date de début :</label>
                                            <div className="date-wrapper">
                                                <input type="date" id="start_dt" name="start_dt" value={newUnit.start_dt} onChange={handleInputChange} required />
                                                <FaCalendar />
                                            </div>
                                        </div>
                                        <div>
                                            <label htmlFor="end_dt">Date de fin :</label>
                                            <div className="date-wrapper">
                                                <input type="date" id="end_dt" name="end_dt" value={newUnit.end_dt} onChange={handleInputChange} min={newUnit.start_dt} max={endDateMax} disabled={!newUnit.start_dt} required />
                                                <FaCalendar />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-buttons">
                                        <button type="submit" className="btn-primary" disabled={formLoading}>
                                            {formLoading ? 'Création...' : 'Créer'}
                                        </button>
                                        <button type="button" className="btn-secondary" onClick={() => navigate('/dashboard')}>
                                            Annuler
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </section>
                </main>
            </div>
        </div>
    );
};

export default AddUnit;